<template>
  <div class="content">
    <!-- <base-header class="pb-6">
      <div class="row align-items-center py-2">
        <div class="col-lg-6 col-7"></div>
      </div>
    </base-header> -->
    <!-- <div class="resources-wrap">
      <div>
        <card class="no-border-card card-with-table" body-classes="px-0 pb-1" footer-classes="pb-2">
          <template slot="header">
            <h2 class="mb-0">Resources</h2>
          </template>
          <div class="col-sm-12">
            <div class="row">
              <div class="col-md-12 user-eltable table-style-normal no-header-bg">
                <el-table role="table" class="courseresGrid" :data="tbl2_data"
                  header-row-class-name="thead-light custom-thead-light">
                  <el-table-column min-width="300px" align="left" label="Course Name" prop="course_name">
                    <template slot-scope="propss">
                      {{ propss.row.course_name }}
                    </template>
                  </el-table-column>
                  <el-table-column min-width="300px" label="Resources">
                    <template slot-scope="propss">
                      <div class="" v-for="resource in propss.row.course_resources" :key="resource.id">
                        <div class="row">
                          <div class="col-md-12">
                            {{ resource.name }}
                          </div>
                        </div>
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column min-width="150px" label="Action">
                    <template slot-scope="propss">
                      <div class="openlink-action" v-for="resource in propss.row.course_resources" :key="resource.id">
                        <a v-if="
                          resource.type == 'file' &&
                          resource.file_name != null
                        " target="_blank" :href="resource.url" class="" title="Download" style="color: white"><i
                            name="Resources Download" class="text-warning fa fa-download"></i>
                        </a>
                        <a v-if="resource.type == 'link' && resource.url != null" target="_blank" :href="resource.url"
                          class="" title="Open Link">
                          <i name="Open Resources Link" class="fa fa-link"></i>
                        </a>
                      </div>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </div>
          </div>
        </card>
      </div>
    </div> -->
    <card class="no-border-card" body-classes="" footer-classes="pb-2">
      <!-- <template slot="header">
            <h2 class="mb-0">Resources</h2>
      </template> -->

      <div class="resource-list-shell" v-if="tbl2_data.length > 0">
        <div class="course-resource-block" v-for="resource in tbl2_data" :key="resource.id">
          <div class="course-resource-header">
            <h5 class="mb-0">{{ resource.course_name }}</h5>
            <span class="resource-count">{{ resource.course_resources.length }} item(s)</span>
          </div>
          <ul class="resource-list mb-0">
            <li
              v-for="res in resource.course_resources"
              :key="res.id"
              class="resource-list-item"
            >
              <span class="res-name">{{ res.name }}</span>
              <span class="resource-actions">
                <button
                  v-if="res.type == 'file' && res.file_name != null"
                  type="button"
                  class="resource-action-btn"
                  @click.prevent="downloadFile(res)"
                >
                  Download
                </button>
                <a
                  v-if="res.type == 'link' && res.url != null"
                  target="_blank"
                  :href="res.url"
                  class="resource-action-link"
                  title="Open Link"
                >
                  Open Link
                </a>
              </span>
            </li>
          </ul>
        </div>
      </div>
      <div class="grid-wrap border rounded p-3" v-else>
          <img :src="emptySlotIcon" alt="No data available" class="w-100"
            style="max-width: 300px; margin: 0 auto; display: block;">
      </div>



    </card>
  </div>
</template>
<script>
import { Table, TableColumn, Select, Option } from "element-ui";
import serverSidePaginationMixin from "../Tables/PaginatedTables/serverSidePaginationMixin";
import "sweetalert2/src/sweetalert2.scss";

export default {
  mixins: [serverSidePaginationMixin],
  components: {
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
  },
  data() {
    return {
      hot_user: "",
      hot_token: "",
      user_id: "",
      tbl2_data: [],
      editor: "",
    };
  },
  computed: {
    isSafeDig() {
      return process.env.VUE_APP_COMPANY_NAME_FRONTEND === "safedig";
    },
    downloadIcon() {
      return this.isSafeDig
        ? require("@/assets/safe-dig/svg-icons/download_icon.svg")
        : "/img/icons/common/download_icon.svg";
    },
    emptySlotIcon() {
      return this.isSafeDig
        ? require("@/assets/safe-dig/svg-icons/safedig_empty_slot.svg")
        : "img/theme/empty_slot.png";
    },
  },

  created: function () {
    if (localStorage.getItem("hot-token")) {
      this.hot_user = localStorage.getItem("hot-user");
      this.hot_token = localStorage.getItem("hot-token");
      if (this.hot_user === "company-admin") {
        this.user_id = localStorage.getItem("hot-admin-id");
      } else {
        this.user_id = localStorage.getItem("hot-user-id");
      }
    }
    if (localStorage.getItem("hot-user") === "employee") {
      this.editor = "employee";
    }
    this.$http
      .post("employees/resources_course_optimized", {
        employee_id: this.user_id,
      })
      .then((resp) => {
        let course_data = resp.data.courses;

        for (let course of course_data) {
          let obj = {
            course_name: course.name,
            id: course.course_id,
            course_resources: [],
          };
          obj.course_resources = course.course_resources;
          if (obj.course_resources.length > 0) {
            this.tbl2_data.push(obj);
          }
        }
      });
  },
  methods: {
async downloadFile(res) {
  try {
    const response = await this.$http.post("force-download", {
      file: res
    }, {
      responseType: 'blob',
    });

    const blob = new Blob([response.data], { type: 'application/pdf' });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', res.name || 'download.pdf'); // ✅ Fix: use actual filename
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  } catch (error) {
    console.error("Download failed:", error);
    this.$swal({
      title: "Error",
      text: "Failed to download file.",
      icon: "error",
    });
  }
}

  },
};
</script>
<style scoped>
.no-border-card .card-footer {
  border-top: 0;
}

.resource-list-shell {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.course-resource-block {
  border: 1px solid #e6ebf1;
  border-radius: 12px;
  background: #ffffff;
}

.course-resource-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 14px 16px;
  border-bottom: 1px solid #eef2f7;
}

.course-resource-header h5 {
  color: #2d3954;
  font-size: 16px;
  font-weight: 600;
}

.resource-count {
  color: #6b7a99;
  font-size: 12px;
  font-weight: 600;
}

.resource-list {
  list-style: none;
  padding: 0;
}

.resource-list-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 12px 16px;
  border-bottom: 1px solid #f3f5f9;
}

.resource-list-item:last-child {
  border-bottom: 0;
}

.res-name {
  color: #344767;
  font-size: 14px;
}

.resource-actions {
  display: inline-flex;
  gap: 10px;
  flex-shrink: 0;
}

.resource-action-btn,
.resource-action-link {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 92px;
  height: 34px;
  border-radius: 8px;
  border: 1px solid #cfd7e5;
  background: #ffffff;
  color: #2d4f85;
  font-size: 12px;
  font-weight: 600;
  text-decoration: none;
  transition: all 0.2s ease;
}

.resource-action-btn:hover,
.resource-action-link:hover {
  border-color: #2d4f85;
  background: #f5f8ff;
}

.resource-action-btn {
  cursor: pointer;
}

@media (max-width: 767px) {
  .course-resource-header,
  .resource-list-item {
    flex-direction: column;
    align-items: flex-start;
  }
}

@media only screen and (max-width: 1024px),
(min-device-width: 768px) and (max-device-width: 1024px) {
  .courseresGrid>>>table.el-table__body td:nth-of-type(1):before {
    content: "Courses";
  }

  .courseresGrid>>>table.el-table__body td:nth-of-type(2):before {
    content: "Resources";
  }

  .courseresGrid>>>table.el-table__body td:nth-of-type(3):before {
    content: "Action";
  }
}
</style>
